import React from 'react'
import PropTypes from 'prop-types'
import { modes } from 'utils/redux/config/modes'
import Header from 'components/Header'
import Footer from 'components/Footer'
//import BlogPostsContainer from 'containers/BlogPostsContainer'
import CurrencyListContainer from 'containers/CurrencyListContainer'
import CryptoCurrencyListContainer from 'containers/CryptoCurrencyListContainer'
import MobileApp from 'components/MobileApp'
import Aux from 'hoc/Auxiliary'
import Meta from 'components/Meta'
import Ad from 'components/Ad'

export const View = ({ mode }) => {
	const modeSettings = modes[mode]
	const title = `Намери и сравни нивата на най-търсените ${modeSettings.namePl.toLowerCase()}`
	return <Aux>
		<Meta page={mode === 'monetary' ? 'currencies' : 'cryptocurrencies'} />
		<Header title={title} isHome showModeBtn showCalculator showFeatured selectedMode={mode} />
		<div className='c-content'>
			<div className='o-wrapper u-padding-top u-padding-bottom-large'>
				<div className='o-layout'>
					<div className='o-layout__item u-1/1 u-margin-bottom'>
						{/*AdSense*/}
						<Ad
							slot='8964911600'
							style={{ display: 'block', height: 120 }}
						/>
					</div>
				</div>
				{
					mode === 'monetary'
						? <CurrencyListContainer title={modeSettings.namePl} mode={mode} />
						: <CryptoCurrencyListContainer title={modeSettings.namePl} mode={mode} />
				}
			</div>
			{/*Mobile app section*/}
			<MobileApp mode={mode} />
			{/*Hide blog section for now*/}
			{/*<div className='u-margin-top-extralarge u-margin-bottom u-margin-top-none@tablet u-padding-vertical-large@desktop'>*/}
			{/*<div className='o-wrapper'>*/}
			{/*<BlogPostsContainer />*/}
			{/*</div>*/}
			{/*</div>*/}
		</div>
		<Footer selectedMode={mode} />
	</Aux>
}

View.propTypes = {
	mode: PropTypes.string
}

export default View
